/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { SessionProvider } from '../../contexts/sessionContext';

export interface IAuthenticatedRouteProps extends RouteProps {
  title: string;
  path: string;
  component: any;
  query?: string;
  children?: React.ReactNode;
}

const AuthenticatedRoute: React.FC<IAuthenticatedRouteProps> = ({
  component: Component,
  ...props
}) => {
  const renderComponent = (routeProps: RouteProps): JSX.Element => {
    return (
      <SessionProvider>
        <Component {...routeProps} />
      </SessionProvider>
    );
  };

  return (
    <Route
      {...props}
      render={(routeProps): JSX.Element => renderComponent(routeProps)}
    />
  );
};

export default memo(AuthenticatedRoute);
